import React from "react";
import PageHeader from "../../../../components/headers/PageHeader";
import castel from "../../../../assets/Images/castel.jpg";
import "./Eu.css";
import { Link } from "react-router-dom";
import Flag from "react-world-flags";

export default function EU() {
    return (
        <div className="eu-page">
            <PageHeader
                mediaSrc={castel}
                mediaType="image"
                title="European CE Mark Medical Device (EU MDR) Consultant"
                slogan=""
            />

            <section className="eu-section eu-introSection">
                <h2>EU MDR and CE Marking Support for Medical Devices</h2>

                <p>
                    The European Union Medical Device Regulation 2017/745 establishes a
                    detailed regulatory framework for placing medical devices on the EU
                    market. Achieving CE Marking requires a structured approach covering
                    product classification, technical documentation, clinical evaluation,
                    risk management, quality systems, labeling, post-market surveillance,
                    and notified body interaction where applicable.
                </p>

                <p>
                    Eupraxia supports medical device companies with practical EU MDR
                    consulting services designed to help prepare compliant documentation,
                    close regulatory gaps, and maintain readiness throughout the device
                    lifecycle. Our approach combines regulatory strategy, technical file
                    development, quality system alignment, and post-market compliance
                    support.
                </p>
            </section>

            <section className="eu-section">
                <h2>European Market Access Through Structured CE Marking</h2>

                <p>
                    CE Marking is not only a product approval milestone; it is a complete
                    demonstration that the device meets applicable safety, performance,
                    quality, and clinical requirements under EU MDR. We help manufacturers
                    organize the evidence needed for conformity assessment and prepare
                    documentation that can withstand notified body and regulatory review.
                </p>
            </section>

            <section className="eu-section eu-servicesSection">
                <h2>Our EU MDR Services</h2>

                <p className="eu-sectionIntro">
                    We provide focused regulatory and technical support across the major
                    requirements involved in CE Marking and EU MDR compliance.
                </p>

                <div className="eu-cardGrid">
                    <article className="eu-card">
                        <h3>Product Classification</h3>
                        <p>
                            Assistance with identifying the correct device classification
                            under EU MDR based on intended purpose, duration of use,
                            invasiveness, technology, risk profile, and applicable
                            classification rules.
                        </p>
                    </article>

                    <article className="eu-card">
                        <h3>Applicable Standards and Testing Review</h3>
                        <p>
                            Review of harmonized standards, common specifications, product
                            testing expectations, safety requirements, performance evidence,
                            and documentation needed to support conformity.
                        </p>
                    </article>

                    <article className="eu-card">
                        <h3>Technical File Compilation</h3>
                        <p>
                            Development or review of Technical Files in line with EU MDR
                            Annex II and Annex III, including device description, design
                            information, risk management, verification, validation, labeling,
                            and PMS documentation.
                        </p>
                    </article>

                    <article className="eu-card">
                        <h3>Marketing Material, Labeling, and IFU Review</h3>
                        <p>
                            Compliance review of labels, instructions for use, brochures,
                            websites, claims, and marketing materials to ensure consistency
                            with intended use, clinical evidence, and EU MDR requirements.
                        </p>
                    </article>

                    <article className="eu-card">
                        <h3>General Safety and Performance Requirements</h3>
                        <p>
                            Support in mapping device evidence against applicable General
                            Safety and Performance Requirements and preparing clear GSPR
                            checklists with objective evidence references.
                        </p>
                    </article>

                    <article className="eu-card">
                        <h3>Clinical Evaluation Report</h3>
                        <p>
                            Preparation or review of Clinical Evaluation Reports based on
                            available clinical data, literature, equivalence considerations,
                            post-market data, and the device’s clinical benefit-risk profile.
                        </p>
                    </article>

                    <article className="eu-card">
                        <h3>ISO 13485 Quality System Alignment</h3>
                        <p>
                            Support for implementing, adjusting, and maintaining a quality
                            management system aligned with ISO 13485 and EU MDR expectations
                            for medical device manufacturers.
                        </p>
                    </article>

                    <article className="eu-card">
                        <h3>European Authorized Representative Support</h3>
                        <p>
                            Guidance for non-EU manufacturers requiring European Authorized
                            Representative services, including documentation readiness,
                            regulatory communication, and market access coordination.
                        </p>
                    </article>

                    <article className="eu-card">
                        <h3>Risk Management Under ISO 14971</h3>
                        <p>
                            Assistance with risk assessment, risk control documentation,
                            benefit-risk analysis, residual risk evaluation, and alignment of
                            risk management outputs with clinical and technical evidence.
                        </p>
                    </article>

                    <article className="eu-card">
                        <h3>Vigilance and Post-Market Surveillance</h3>
                        <p>
                            Development of PMS plans, PMCF strategy, vigilance procedures,
                            trend reporting processes, field safety corrective action
                            documentation, and post-market lifecycle compliance support.
                        </p>
                    </article>
                </div>
            </section>

            <section className="eu-section eu-detailSection">
                <h2>How We Support EU MDR Readiness</h2>

                <div className="eu-infoGrid">
                    <article className="eu-infoBox">
                        <h3>Gap Assessment</h3>
                        <p>
                            We review existing documentation and identify gaps against EU
                            MDR expectations, including technical, clinical, quality, PMS,
                            and labeling requirements.
                        </p>
                    </article>

                    <article className="eu-infoBox">
                        <h3>Documentation Development</h3>
                        <p>
                            We help prepare structured, review-ready documentation for
                            Technical File submission, notified body review, internal audit,
                            and regulatory lifecycle management.
                        </p>
                    </article>

                    <article className="eu-infoBox">
                        <h3>Lifecycle Maintenance</h3>
                        <p>
                            We support updates to technical documentation, PMS outputs,
                            clinical evaluation, labeling, risk files, and change-related
                            regulatory records after CE Marking.
                        </p>
                    </article>
                </div>
            </section>

            <section className="eu-section eu-offerSection">
                <h2>Other Services You May Find Valuable</h2>

                <div className="eu-regGrid">
                    <Link
                        to="/MedicalDevice/UsFDA"
                        className="eu-regCard"
                        aria-label="USA FDA"
                    >
                        <header className="eu-regHead">
                            <Flag code="US" className="eu-regFlag" title="United States" />
                            <h3>USA FDA</h3>
                        </header>

                        <p>
                            510(k), De Novo, and PMA submissions, labeling/IFU compliance,
                            and robust PMS and vigilance documentation.
                        </p>
                    </Link>

                    <Link
                        to="/MedicalDevice/CDSCO"
                        className="eu-regCard"
                        aria-label="India CDSCO"
                    >
                        <header className="eu-regHead">
                            <Flag code="IN" className="eu-regFlag" title="India" />
                            <h3>India CDSCO</h3>
                        </header>

                        <p>
                            Manufacturing, import, and wholesale licenses, Indian Agent
                            services, and end-to-end dossier preparation.
                        </p>
                    </Link>
                </div>
            </section>
        </div>
    );
}